<template>
  <div class="container">
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h2>Fractionalization</h2>
            <br />
            <div class="row">
              <div class="col-md">
                <!-- End token symbol instructions -->
                <!-- Token symbol and validations -->
                <h4>Token Symbol</h4>
                <div class="form-row">
                  <div class="form-group col-md">
                    <form class="mt-3">
                      <div class="form-group">
                        <input
                          id="token_symbol"
                          v-model="token_symbol"
                          disabled
                          type="text"
                          class="form-control form-control-lg text-uppercase"
                          aria-describedby="name"
                          placeholder="token symbol"
                          @keyup="flag_change = false"
                        />
                      </div>
                    </form>
                  </div>
                  <!-- End token symbol and validations -->
                </div>
                <br />
                <br />
                <br />
                <!-- Coordinates -->
                <div class="row">
                  <div class="col-md-6 col-sm-6">
                    <h3>
                      Coordinates
                      <!--
                      <button
                        type="button"
                        class="btn btn-outline-info btn-sm btn-rounded"
                        @click="
                          show_popup_coordinates = !show_popup_coordinates
                        "
                      >
                        <i class="fas fa-info"></i>
                      </button>
                      -->
                    </h3>
                  </div>
                </div>
                <!-- Pop-up coordinates-->
                <!--
                <div
                  v-show="show_popup_coordinates"
                  class="alert alert-info alert-dismissible border-0 fade show mt-1"
                  role="alert"
                >
                  <button
                    type="button"
                    class="close"
                    @click="show_popup_coordinates = !show_popup_coordinates"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  To obtain the coordinates of the asset, it's recommended to
                  indicate the city in the address field and place the map
                  marker at the point of the asset.
                </div>
                -->
                <!-- End pop-up coordinates -->
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <form class="mt-1">
                      <label for="asset_latitude">Latitude</label>
                      <div class="form-group">
                        <input
                          id="asset_latitude"
                          v-model="latitude"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </form>
                  </div>
                  <div class="form-group col-md-4">
                    <form>
                      <label for="asset_longitude">Longitude</label>
                      <div class="form-group mt-1">
                        <input
                          id="asset_longitude"
                          v-model="longitude"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </form>
                  </div>
                  <!-- End coordinates -->
                  <!-- Fly function -->
                  <div class="form-group col-md-3">
                    <button
                      id="fly"
                      type="button"
                      class="mt-4 p-3 btn btn-outline-primary btn-rounded"
                      @click="resize(), flyTo()"
                    >
                      Fly
                    </button>
                  </div>
                  <!-- End fly function -->
                </div>
              </div>
              <!-- Asset dimensions form -->
              <div class="form-group col-md">
                <div class="form-row mt-1">
                  <div class="form-group col-md-9">
                    <form>
                      <label for="asset_dimensions">Asset Dimensions</label>
                      <div class="form-group mt-1">
                        <input
                          id="asset_dimensions"
                          v-model="asset_dimensions"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </form>
                  </div>
                  <div class="form-group col-md-3">
                    <form>
                      <label for="asset_unit_token">Unit</label>
                      <div class="form-group mt-1">
                        <div class="form-group mt-1 bg-light">
                          <p class="text-muted p-2">
                            {{ asset_units ? asset_units : 'BLANK' }}
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- End asset dimensions form -->
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <!-- Map style switch -->
                <div class="form-group col-md-6">
                  <label>View</label>
                  <div class="custom-control custom-switch">
                    <input
                      id="view"
                      v-model="map_view"
                      type="checkbox"
                      class="custom-control-input"
                      @click="reload_map"
                    />
                    <label class="custom-control-label" for="view">
                      Satelite / Street
                    </label>
                  </div>
                </div>
                <!-- End map style switch -->
              </div>
              <!--<div class="col-md-6">
                <form>
                  <label for="asset_decimals">Aproximate area m2 </label>
                  <div class="form-group mt-1">
                    <input
                      id="area"
                      v-model="area"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </form>
              </div>-->
              <!--<p id="info"></p>-->
            </div>

            <div class="row">
              <div class="col-md-12">
                <div id="map1" class="map"></div>
              </div>
            </div>
            <br />
            <br />
            <!-- Map div -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import './styles/asset_styles.css'; /* switch Button styles*/
@import './styles/fractionalization.css'; /* styles  of the view */

.blank_block {
  visibility: hidden;
}
</style>

<script>
import * as move_tabs from './js/movetabs';
// import * as utils from './js/utils';
import * as mapboxgl from 'mapbox-gl';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import * as MapboxDraw from '@mapbox/mapbox-gl-draw';
import * as convert from 'convert-units';
import * as turf from '@turf/turf';
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from 'vuelidate/lib/validators';
require('es6-promise').polyfill();

export default {
  name: 'AssetFractionalization',
  components: {},
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      token_symbol: '',
      token_symbol_asset: '',
      token_symbol_Preview: '',
      generate_tokens_each: 0,
      total_tokens: 0,
      decimals: 0,
      map: null,
      geocoder: null,
      map_styles: '',
      is_divisible: false,
      is_convert: false,
      map_view: false,
      latitude: 10.1727434,
      longitude: -68.0642651,
      show_popup_coordinates: false,
      show_popup_decimals: false,
      value_conversion: 0,
      from: '',
      to: '',
      asset_dimensions: 0,
      asset_units: '',
      asset_convertion_units: '',
      assetId: '',
      userId: '',
      available: false,
      not_available: false,
      draw: null,
      area: 0,
      flag_change: false,
    };
  },
  computed: {
    generate_total_tokens: function() {
      const number_of_tokens =
        parseFloat(this.asset_dimensions) /
        parseFloat(this.generate_tokens_each);
      if (
        parseFloat(this.generate_tokens_each) >
        parseFloat(this.asset_dimensions)
      )
        return -1;
      else if (
        parseFloat(this.generate_tokens_each) < 0 ||
        parseFloat(this.asset_dimensions) < 0
      )
        return -2;
      else if (!isFinite(number_of_tokens)) return -3;
      return number_of_tokens.toFixed(this.decimals);
    },
  },
  validations() {
    return {
      token_symbol: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(6),
      },
      asset_units: {
        required,
      },
      asset_dimensions: {
        minValue: minValue(0),
      },
      generate_tokens_each: {
        maxValue: maxValue(this.asset_dimensions),
        minValue: minValue(0),
      },
    };
  },
  mounted() {
    this.map_styles = 'mapbox://styles/mapbox/satellite-v9';
    this.longitude = -91.87611;
    this.latitude = 42.75978;
    this.create_map();
    //document.getElementById('buttonhidden').click();

    /*window.$(function() {
      window.$('btnhidden').trigger('click');
    });*/
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem('user')).userId;
    this.assetId = this.$store.state.assetId;
    this.getAsset();
  },
  methods: {
    resize() {
      this.map.resize();
    },
    getAsset() {
      this.$http
        .get(`/asset/Fract/Data?assetId=${this.assetId}`)
        .then(({ data }) => {
          this.assetId = data.AssetFract.assetId;
          this.userId = data.AssetFract.userId;
          this.asset_dimensions = data.AssetFract.dimension;
          this.token_symbol = data.AssetFract.tokenSimbol;
          this.generate_total_tokens = data.AssetFract.tokenTotal;
          this.generate_tokens_each = data.AssetFract.tokenxUnit;
          this.latitude = data.AssetFract.latitude;
          this.longitude = data.AssetFract.longitude;
          this.decimals = data.AssetFract.tdecimals;
          this.asset_units = data.AssetFract.unitD;
        })
        .catch(err => {
          this.message.msg = err.response.data.message;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
        });
    },
    drawGrid() {
      let lines;
      /* se obtiene el array de coodenadas del poligono dibujado en el mapa
      y se convierte a un objeto line de Turf*/
      this.updateArea();
      lines = turf.lineString(
        this.draw.getAll().features[0].geometry.coordinates[0]
      );
      //console.log(this.draw.getAll().features[0].geometry.coordinates[0]);
      //let mask = turf.polygon([this.draw.getAll().features[0].geometry.coordinates[0]]);
      // Se crea el Bounding Box del area, partiendo del poligono
      let bbox = turf.bbox(lines);

      // *********************** Dibujando Cuadricula *************************

      /* se selecciona el tamaño de cada celda y su unidad */
      let cellSide = 1;
      let options = {
        units: 'meters',
        //mask: mask
      };
      // Se crea el objeto GeoJson que representa la cuadricula mediante Turf
      let squareGrid = turf.squareGrid(bbox, cellSide, options);
      console.log(squareGrid);

      // se pregunta si el mapa ya tiene una capa llamada "grid"
      let grid = this.map.getSource('grid');
      // si no la tiene, se crea la capa con la data de Turf
      if (grid === undefined) {
        console.log('entra');
        this.map.addSource('grid', {
          type: 'geojson',
          data: squareGrid,
        });

        // Create a new layer, which loads data from the newly created data source
        this.map.addLayer({
          id: 'grid_layer',
          type: 'line',
          source: 'grid',
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': '#fff',
            'line-width': 0.1,
          },
        });
      } else {
        // si la capa existe previamente, solo se actualiza la data
        this.map.getSource('grid').setData(squareGrid);
      }
    },
    deleteGrid() {
      //se obtiene la capa de la grid del mapa
      let grid_layer = this.map.getLayer('grid_layer');
      // si la capa existe, se oculta
      if (typeof grid_layer !== 'undefined') {
        this.map.removeLayer('grid_layer');
        this.map.removeSource('grid');
      }
    },
    updateArea() {
      let data = this.draw.getAll();
      if (data.features.length > 0) {
        let area = turf.area(data);
        // restrict to area to 2 decimal points
        this.area = Math.round(area * 100) / 100;
      } else {
        this.area = 0;
      }
    },
    create_map() {
      mapboxgl.accessToken =
        'pk.eyJ1Ijoic21vdGE5MyIsImEiOiJjazN1Z2JlaWUwMjU1M3BsYjJmeGUzMHBmIn0.PbaSprWnqZvmoJL847CPUQ';

      // eslint-disable-next-line no-unused-vars
      this.map = new mapboxgl.Map({
        container: 'map1',
        style: this.map_styles,
        center: [this.longitude, this.latitude], // starting position
        zoom: 17.5, // starting zoom
        //interactive: true,
      });
      this.map.addControl(new mapboxgl.NavigationControl());
      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
      });

      let mapCanvas = document.getElementsByClassName('mapboxgl-canvas');
      mapCanvas[0].style = 'width:100%; height: 400px;';
      this.map.addControl(this.draw);

      /*this.map.on('draw.create', this.drawGrid);
      this.map.on('draw.delete', this.deleteGrid);
      this.map.on('draw.update', this.drawGrid);*/

      this.geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
      });

      document
        .getElementById('geocoder')
        .appendChild(this.geocoder.onAdd(this.map));

      /*this.map.on('mousemove', function(e) {
        document.getElementById('info').innerHTML =
          // e.point is the x, y coordinates of the mousemove event relative
          // to the top-left corner of the map
          JSON.stringify(e.point) +
          '<br />' +
          // e.lngLat is the longitude, latitude geographical position of the event
          JSON.stringify(e.lngLat.wrap());
      });*/
    },
    flyTo() {
      console.log('HOLA');
      this.map.flyTo({
        center: [this.longitude, this.latitude],
        essential: true, // this animation is considered essential with respect to prefers-reduced-motion
      });
    },
    reload_map() {
      if (!this.map_view)
        this.map_styles = 'mapbox://styles/mapbox/streets-v11';
      else this.map_styles = 'mapbox://styles/mapbox/satellite-v9';
      this.map.setStyle(this.map_styles);
    },
    changeTabAndNextStep() {
      // wait 2 seconds to change the panel and move the step-bar
      setTimeout(() => {
        this.$emit('update', 5);
        move_tabs.moveTab();
      }, 2000);
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
    emptyFields() {
      return (
        this.asset_dimensions === '' ||
        this.token_symbol === '' ||
        this.generate_total_tokens === '' ||
        this.generate_tokens_each === '' ||
        this.latitude === '' ||
        this.longitude === '' ||
        this.available === false
      );
    },
    convert_to() {
      // Maurizio method
      /*const converted = utils.unit_convertion(
        this.asset_dimensions,
        this.asset_units,
        this.asset_convertion_units
      );*/

      // Using a librarie
      /* Possible inputs:
        - mm2
        - cm2
        - m2
        - ha
        - km2
        - in2
        - ft2
        - ac
        - mi2
      */
      // Example: convert(1).from('lb').to('kg')
      //console.log('decimals: ' + this.asset_dimensions_all_decimals);

      let converted = convert(this.asset_dimensions)
        .from(this.asset_units)
        .to(this.asset_convertion_units);
      if (converted === 0) this.asset_dimensions = 'Error converting units';
      else {
        this.asset_dimensions = converted;
        this.asset_units = this.asset_convertion_units;
      }
    },
    IsAvailable() {
      this.token_symbol = this.token_symbol.toUpperCase();
      this.$http
        .get(`/asset/Fract/verificate?tokenSimbol=${this.token_symbol}`)
        .then(resp => {
          this.available = resp.data.ok;
          this.token_symbol_asset = this.token_symbol;
        })
        .catch(() => {
          this.available = false;
          this.token_symbol_asset = this.token_symbol;
        });
    },
    GetAssetInfo() {
      this.$http.get(`/asset/Info/Data?assetId=${this.assetId}`).then(res => {
        this.NamePreview(res.data.assetInfo.assetName);
      });
    },
    NamePreview(Name) {
      const ArrayName = Name.split(' ');
      let NewString = '';
      let Aux = 0;
      if (ArrayName.length > 2) {
        if (ArrayName.length > 6) {
          Aux = 6;
        } else {
          Aux = ArrayName.length;
        }
        for (let i = 0; i < Aux; i += 1) {
          NewString = NewString.concat(ArrayName[i][0]);
        }
        NewString = NewString.toUpperCase();
      } else {
        if (
          ArrayName.length === 1 &&
          ArrayName[0].length > 2 &&
          ArrayName[0].length < 6
        ) {
          NewString = ArrayName[0].toUpperCase();
        } else {
          if (ArrayName.length === 0) {
            NewString = null;
          } else {
            if (ArrayName[0].length > 2 && ArrayName[1].length > 2) {
              NewString = NewString.concat(
                ArrayName[0][0],
                ArrayName[0][1],
                ArrayName[0][2],
                ArrayName[1][0],
                ArrayName[1][1],
                ArrayName[1][2]
              );
            } else {
              NewString = null;
            }
          }
        }
      }
      this.token_symbol_Preview = NewString;
    },
    updateLocalStorage() {
      let asset = JSON.parse(localStorage.getItem('asset'));
      asset.token_symbol = this.token_symbol;
      asset.total_tokens = parseFloat(this.generate_total_tokens);
      asset.decimals = this.decimals;
      localStorage.setItem('asset', JSON.stringify(asset));
    },
  },
};
</script>

/*this.map.on('load', function() { let mapCanvas =
document.getElementsByClassName('mapboxgl-canvas'); mapCanvas[0].style = 'width:
100%; height: 400px;'; let h = this; setTimeout(() => { h.map.resize(); },
2000); });*/
